import { usePathname } from "expo-router";
import { useEffect } from "react";

import { addBreadcrumb } from "@/sentry";

export const useBrowserHistoryBreadcrumb = () => {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window === "undefined") return;

    const handlePopState = () => {
      addBreadcrumb({
        category: "navigation",
        message: `Browser back/forward button pressed — ${pathname} → ${window.location.pathname}`,
        level: "info",
      });
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [pathname]);
};
